import { Drawer, Flexer, Heading, ModalClose, Text, View } from '@fold-dev/core'
import { useEffect, useState } from 'react'

//import { LoadingComponent } from '../components/loading.component'

export const InboxModal = ({ onDismiss }) => {
    const [page, setPage] = useState(0)
    const [loading, setLoading] = useState(false)

    const fetchData = async () => {
        /* setLoading(true)
        setError(false)

        try {
            const { data } = await GraphqlService.getInstance().notifications(userId, page)

            setLoading(false)
            setPage(page + 1)
            dispatch(hydrateNotifications(data.notifications))
        } catch (e) {
            logger(e)
            setLoading(false)
            setError(typeof e == 'string' ? e : 'An error occured')
        } */
    }

    const handleReadButtonClick = async (notificationId, read) => {
        /*   setLoading(true)
        setError(false)

        try {
            await GraphqlService.getInstance().updateNotificationRead(notificationId, read)

            setLoading(false)
            dispatch(updateNotificationRead(notificationId, read))
        } catch (e) {
            setLoading(false)
            setError(false)
        } */
    }

    const handleLoadButtonClick = () => {
        setPage(page + 1)
    }

    // Get all the teams
    useEffect(() => {
        fetchData()
    }, [page])

    return (
        <Drawer
            width="50%"
            anchor="left"
            onDismiss={onDismiss}
            isVisible={true}
            header={
                <>
                    <Heading>Inbox</Heading>
                    <Flexer />
                    <ModalClose onClick={onDismiss} />
                </>
            }>
            {/*       <LoadingComponent loading={loading} /> */}

            <View column>
                {/*   
                <ScrollView>
                    {notifications.map((notification, index) => {
                        return (
                            <Row key={index} className="row">
                                <div className="flexer column">
                                    <div className="row w-100 flexer">
                                        <div className="column w-100">
                                            <div className="row mb-5 w-100">
                                                <Team hasProject={notification.project.id}>
                                                    {notification.team.name}
                                                </Team>
                                                {notification.project.id && (
                                                    <Project
                                                        onClick={() => {
                                                            setNotificationsMenu(false)
                                                            browserHistory.push(
                                                                `/app/team/${notification.team.id}/c/${notification.project.id}`
                                                            )
                                                        }}
                                                    >
                                                        {notification.project.name}
                                                    </Project>
                                                )}
                                                <div className="flexer" />
                                                <Created>{moment(notification.createdAt).fromNow()}</Created>
                                            </div>
                                            <Title read={notification.read}>{notification.title}</Title>
                                            <Body read={notification.read}>{notification.body}</Body>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <Button
                                            className="button"
                                            onClick={() =>
                                                handleReadButtonClick(notification.id, !notification.read)
                                            }
                                        >
                                            {notification.read ? 'Mark as unread' : 'Mark as read'}
                                        </Button>
                                    </div>
                                </div>
                            </Row>
                        )
                    })}

                    {notifications.length == 0 && (
                        <>
                            <img src="icon.svg" width="100" className="mt-40 mb-20" />
                            <TitleText>Hooray</TitleText>
                            <SubtitleText>You are all caught up</SubtitleText>
                        </>
                    )}

                    <br />
                    <br />
                </ScrollView> 
                */}

                <View
                    row
                    onClick={handleLoadButtonClick}>
                    <Text>More</Text>
                </View>
            </View>
        </Drawer>
    )
}
